import Alpine from "alpinejs";

Alpine.magic("algoliasearch", () => async (appId, apiKey) => {
    const { default: algoliasearch } = await import("algoliasearch/dist/algoliasearch-lite.esm.browser");
    return algoliasearch(appId, apiKey);
});